import React, { useState } from "react";
import { Trans } from "@lingui/react/macro";
import { sharedStyles } from "./_shared";
import JourneyModal from "./JourneyModal";

const ctaStyles = `
.tr-jcta-wrap {
  padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px);
  max-width: 1200px;
  margin: 0 auto;
}
.tr-jcta-card {
  position: relative;
  border-radius: 22px;
  overflow: hidden;
  isolation: isolate;
  min-height: 220px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, var(--tr-primary, #20C997) 0%, var(--tr-secondary, #2B70A9) 100%);
  box-shadow: 0 8px 32px rgba(0,0,0,.12), 0 2px 8px rgba(0,0,0,.06);
}
.tr-jcta-deco {
  position: absolute;
  inset: 0;
  z-index: 0;
  opacity: 0.18;
  background-image:
    radial-gradient(circle at 12% 20%, rgba(255,255,255,0.55) 0, transparent 30%),
    radial-gradient(circle at 86% 78%, rgba(255,255,255,0.45) 0, transparent 28%);
}
.tr-jcta-content {
  position: relative; z-index: 1;
  padding: clamp(24px, 4vw, 44px);
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 740px;
}
.tr-jcta-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .12em;
  text-transform: uppercase;
  color: #fff;
  background: rgba(255,255,255,.18);
  border: 1px solid rgba(255,255,255,.28);
  padding: 6px 12px;
  border-radius: 999px;
  width: fit-content;
}
.tr-jcta-title {
  margin: 0;
  font-size: clamp(22px, 3.2vw, 32px);
  font-weight: 800;
  letter-spacing: -.01em;
  line-height: 1.15;
}
.tr-jcta-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: rgba(255,255,255,.92);
  max-width: 580px;
}
.tr-jcta-btn {
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 26px;
  border-radius: 12px;
  border: none;
  background: #fff;
  color: var(--tr-primary, #20C997);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  width: fit-content;
  transition: transform 0.15s, box-shadow 0.15s;
  box-shadow: 0 6px 16px rgba(0,0,0,0.18);
}
.tr-jcta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(0,0,0,0.22);
}
`;

export default function JourneyCTA({ context }) {
    const { travel } = context;
    const [open, setOpen] = useState(false);

    if (travel?.journey?.enabled === false) return null;

    const responsable = travel?.bethHabad?.contacts?.[0];
    if (!responsable) return null;

    const primary = travel?.theme?.primaryColor;
    const secondary = travel?.theme?.secondaryColor;
    const cssVars = {};
    if (primary) cssVars["--tr-primary"] = primary;
    if (secondary) cssVars["--tr-secondary"] = secondary;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: sharedStyles + ctaStyles }} />
            <div className="tr-jcta-wrap" style={cssVars}>
                <section className="tr-jcta-card">
                    <div className="tr-jcta-deco" />
                    <div className="tr-jcta-content">
                        <span className="tr-jcta-eyebrow"><Trans>✈️ Vous venez nous voir ?</Trans></span>
                        <h2 className="tr-jcta-title"><Trans>Annoncez votre venue au Beth Habad</Trans></h2>
                        <p className="tr-jcta-text">
                            <Trans>
                                Indiquez-nous vos dates de séjour et le nombre de voyageurs,
                                pour que nous puissions vous accueillir au mieux durant votre séjour.
                            </Trans>
                        </p>
                        <button className="tr-jcta-btn" onClick={() => setOpen(true)}>
                            <Trans>Annoncer ma venue →</Trans>
                        </button>
                    </div>
                </section>
            </div>

            <JourneyModal context={context} open={open} onClose={() => setOpen(false)} />
        </>
    );
}
